function userReducer(currentState = [], action) {
  switch (action.type) {
    case "SET_USER":
        return action.payload.data;
    default:
      break;
  }
  return currentState;
}

export default userReducer;
